import React, { Fragment, useEffect, useState } from 'react';

import getSymbolFromCurrency from 'currency-symbol-map';
import dayjs from 'dayjs';
import { arrayOf, func, number, shape, string } from 'prop-types';

import OneTimeInvoiceAdjustConfirm from './OneTimeInvoiceAdjustConfirm';
import {
  ArrowRightBlackIcon,
  ArrowRightIcon,
  LeftArrowIcon,
} from '../../../../../../../theme/images';
import {
  ModalBox,
  Button,
  GreyCard,
  ErrorMsgBox,
} from '../../../../../../../common';

const InvoiceAdjustConfirm = ({
  onBackClick,
  adjustmentData,
  returnTotalAmount,
  selectedMonthYear,
  invoiceType,
  onApply,
  today,
  formatNumber,
  currencySymbol,
}) => {
  const isPermanentAdditional = invoiceType === 'permanent additional';
  const [showError, setShoeError] = useState(false);
  const { totalCurrentBudget, totalNewBudget } = returnTotalAmount();

  useEffect(() => {
    if (isPermanentAdditional) {
      const isRecordExits = adjustmentData.filter((element) => {
        return element.change && element.change < 0;
      });
      if (isRecordExits.length) {
        setShoeError(true);
      }
    }
  }, [isPermanentAdditional, adjustmentData]);

  const returnInvoiceBillDate = () => {
    if (today > 10) {
      if (invoiceType === 'standard') {
        return `${dayjs(selectedMonthYear?.value)
          .subtract(1, 'M')
          .format('MMMM')}`;
      }
      if (
        dayjs(selectedMonthYear?.value).subtract(1, 'M').format('MMMM') ===
        dayjs().format('MMMM')
      ) {
        return `${dayjs(selectedMonthYear?.value).format('MMMM')}`;
      }
      return `${dayjs(selectedMonthYear?.value).format('MMMM')}`;
    }
    if (invoiceType === 'standard') {
      return `${dayjs(selectedMonthYear?.value)
        .subtract(1, 'M')
        .format('MMMM')}`;
    }
    if (
      dayjs(selectedMonthYear?.value).format('MMMM') !== dayjs().format('MMMM')
    ) {
      return `${dayjs(selectedMonthYear?.value).format('MMMM')}`;
    }
    return `${dayjs().format('MMMM')}`;
  };

  const totalChangeAmount =
    totalNewBudget - totalCurrentBudget > 0
      ? `+${currencySymbol || '$'}${formatNumber(
          Math.abs(totalCurrentBudget - totalNewBudget),
        )}`
      : `-${currencySymbol || '$'}${formatNumber(
          Math.abs(totalCurrentBudget - totalNewBudget),
        )}`;

  const renderResponsiveView = () => {
    return (
      <div className="d-md-none d-block">
        {adjustmentData &&
          adjustmentData.length > 0 &&
          adjustmentData.map((item) => {
            const textClass =
              item.change && item.change !== 0
                ? 'normal-text text-bold'
                : 'gray-normal-text';
            return (
              <Fragment key={item.id}>
                <div className="row">
                  <div className="col-12  text-left">
                    <div className="label">Marketplace</div>
                    <div className={textClass}>{item.marketplace}</div>
                  </div>

                  <div className="col-4 pr-2 text-left">
                    <div className="label">From</div>
                    <div className={textClass}>
                      {formatNumber(
                        item.new_budget,
                        getSymbolFromCurrency(
                          item?.local_currency ? item?.local_currency : 'USD',
                        ),
                      )}
                    </div>
                  </div>
                  <div className="col-2 px-1 text-left">
                    <div className="mt-3">
                      <img src={ArrowRightBlackIcon} width="18px" alt="arrow" />{' '}
                    </div>
                  </div>
                  <div className="col-3 px-1 text-left">
                    <div className="label">To</div>
                    <div className={textClass}>
                      {item.newAmount
                        ? `$${item.newAmount}`
                        : formatNumber(
                            item.new_budget,
                            getSymbolFromCurrency(
                              item?.local_currency
                                ? item?.local_currency
                                : 'USD',
                            ),
                          )}
                    </div>
                  </div>
                  <div className="col-3 pl-1 text-left">
                    <div className="label">Change</div>
                    <div className={textClass}>
                      {item.change
                        ? item.change === 0
                          ? '-'
                          : formatNumber(
                              item.change,
                              getSymbolFromCurrency(
                                item?.local_currency
                                  ? item?.local_currency
                                  : 'USD',
                              ),
                              '',
                              false,
                              true,
                            )
                        : '-'}
                    </div>
                  </div>
                </div>
                <div className=" straight-line horizontal-line mt-2 mb-2 " />
              </Fragment>
            );
          })}

        <div className="row">
          <div className="col-12 text-left">
            <div className="label text-bold"> </div>
            <div className="normal-text text-bold">Total invoice</div>
          </div>

          <div className="col-4 pr-2 text-left">
            <div className="label">From</div>
            <div className="gray-normal-text">
              {formatNumber(totalCurrentBudget, currencySymbol || '$')}
            </div>
          </div>
          <div className="col-2 px-1 text-left">
            <div className="mt-3">
              <img src={ArrowRightIcon} width="18px" alt="arrow" />{' '}
            </div>
          </div>
          <div className="col-3 px-1 text-left">
            <div className="label">To</div>
            <div className="gray-normal-text">
              {formatNumber(totalNewBudget, currencySymbol || '$')}
            </div>
          </div>
          <div className="col-3 pl-1 text-left">
            <div className="label">Change</div>
            <div className="gray-normal-text">{totalChangeAmount}</div>
          </div>
        </div>
      </div>
    );
  };

  const renderDesktopView = () => {
    return (
      <div className="d-md-block d-none">
        <div className="row">
          <div className="col-4 pr-2 text-left">
            <div className="label">Marketplace</div>
          </div>
          <div className="col-3 px-1 text-left">
            <div className="label">From</div>
          </div>
          <div className="col-2 px-1 text-left">
            <div className="label">To</div>
          </div>
          <div className="col-3 pl-1 text-left">
            <div className="label">Change</div>
          </div>
        </div>
        <div className=" straight-line horizontal-line pt-1 mb-2 " />

        {adjustmentData &&
          adjustmentData.length > 0 &&
          adjustmentData.map((item) => {
            const textClass =
              item.change && item.change !== 0
                ? 'normal-text text-bold'
                : 'gray-normal-text';
            return (
              <div key={item.id} className="row mt-1">
                <div className="col-4 pr-2 text-left">
                  <div className={textClass}>{item.marketplace}</div>
                </div>
                <div className="col-2 px-1 text-left">
                  <div className={textClass}>
                    {formatNumber(
                      item.new_budget,
                      getSymbolFromCurrency(
                        item?.local_currency ? item?.local_currency : 'USD',
                      ),
                    )}
                  </div>
                </div>
                <div className="col-1 px-1 text-left">
                  <div className={textClass}>
                    <img src={ArrowRightIcon} width="18px" alt="arrow" />{' '}
                  </div>
                </div>
                <div className="col-2 px-1 text-left">
                  <div className={textClass}>
                    {item.newAmount
                      ? `$${item.newAmount}`
                      : formatNumber(
                          item.new_budget,
                          getSymbolFromCurrency(
                            item?.local_currency ? item?.local_currency : 'USD',
                          ),
                        )}
                  </div>
                </div>
                <div className="col-3 pl-1 text-left">
                  <div className={textClass}>
                    {item.change
                      ? item.change === 0
                        ? '-'
                        : formatNumber(
                            item.change,
                            getSymbolFromCurrency(
                              item?.local_currency
                                ? item?.local_currency
                                : 'USD',
                            ),
                            '',
                            false,
                            true,
                          )
                      : '-'}
                  </div>
                </div>
              </div>
            );
          })}

        <div className=" straight-line horizontal-line pt-1 mb-2 " />
        <div className="row">
          <div className="col-4 pr-2 text-left">
            <div className="normal-text text-bold">Total invoice</div>
          </div>
          <div className="col-2 px-1 text-left">
            <div className="normal-text text-bold">
              {formatNumber(totalCurrentBudget, `${currencySymbol || '$'}`)}
            </div>
          </div>
          <div className="col-1 px-1 text-left">
            <div className="normal-text">
              <img src={ArrowRightBlackIcon} width="18px" alt="arrow" />{' '}
            </div>
          </div>
          <div className="col-2 px-1 text-left">
            <div className="normal-text text-bold">
              {formatNumber(totalNewBudget, `${currencySymbol || '$'}`)}
            </div>
          </div>
          <div className="col-3 pl-1 text-left">
            <div className="normal-text text-bold">{totalChangeAmount}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ModalBox>
        <div style={{ wordBreak: 'break-all' }} className="modal-body pb-0 ">
          <h4 className="mb-3">
            <img
              role="presentation"
              onClick={onBackClick}
              className="modal-back-arrow"
              src={LeftArrowIcon}
              alt="back-arrow"
            />
            Invoice Adjustment
          </h4>
          <div className="body-content">
            <div className=" straight-line horizontal-line pt-1 mb-2 " />
            {invoiceType !== 'one time' ? (
              <>
                {renderDesktopView()}
                {renderResponsiveView()}
              </>
            ) : (
              <OneTimeInvoiceAdjustConfirm
                adjustmentData={adjustmentData}
                totalNewBudget={totalNewBudget}
                formatNumber={formatNumber}
              />
            )}
            <div className=" straight-line horizontal-line mt-2 mb-2 " />
            {invoiceType !== 'one time' ? (
              <p className="normal-text">
                The new invoice amount will be available to spend from{' '}
                <b>
                  {invoiceType === 'standard'
                    ? dayjs(selectedMonthYear?.value).format('MMMM')
                    : dayjs(selectedMonthYear?.value)
                        .add(1, 'M')
                        .format('MMMM')}{' '}
                  onwards.
                </b>
                <br /> The first bill for this amount will be sent{' '}
                {returnInvoiceBillDate()} 11.
              </p>
            ) : null}
            {invoiceType === 'permanent additional' && (
              <GreyCard className="yellow-card">
                <p className="normal-text text-bold m-0">
                  Additional DSP invoice ({returnInvoiceBillDate()} only)
                </p>
                <p className="normal-text text-bold mb-0 mt-1">
                  {' '}
                  {totalChangeAmount.replace('+', '')}
                </p>
                <p className="normal-text mb-0 mt-1">
                  This will be a one-off invoice, providing additional budget to
                  spend in {returnInvoiceBillDate()}. This invoice will be sent
                  as soon as brand partner approves the proposal.
                </p>
              </GreyCard>
            )}
            {invoiceType === 'one time' ? (
              <p className="normal-text mb-0 mt-1">
                The will be a one-off invoice, providing additional budget to
                spend in{' '}
                <b>{dayjs(selectedMonthYear?.value).format('MMMM')} only.</b>
              </p>
            ) : null}
            <div>
              {showError ? (
                <ErrorMsgBox className="mt-3 mb-3" font>
                  Please enter a value that is higher than the initial budget.
                </ErrorMsgBox>
              ) : null}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            onClick={onApply}
            type="button"
            className={
              showError
                ? 'btn-primary on-boarding w-100 disabled '
                : 'btn-primary on-boarding w-100'
            }
          >
            Confirm
          </Button>
        </div>
      </ModalBox>
    </>
  );
};

export default InvoiceAdjustConfirm;

InvoiceAdjustConfirm.defaultProps = {
  onBackClick: () => {},
  adjustmentData: [],
  returnTotalAmount: () => {},
  selectedMonthYear: {},
  onApply: () => {},
};

InvoiceAdjustConfirm.propTypes = {
  onBackClick: func,
  returnTotalAmount: func,
  adjustmentData: arrayOf(Array),
  selectedMonthYear: shape({}),
  invoiceType: string.isRequired,
  currencySymbol: string.isRequired,
  onApply: func,
  today: number.isRequired,
  formatNumber: func.isRequired,
};
